module.exports = __webpack_public_path__ + "static/media/firstflooronly.dea4d958.png";